/**
 * Normalises time strings by removing seconds if present
 * @param time - Time string in HH:mm or HH:mm:ss format
 * @returns Time string in HH:mm format
 */
export const normaliseTime = (time: string | undefined | null): string => {
  if (!time || time.trim() === '') {
    return '';
  }
  return time.substring(0, 5); // Get HH:mm only
};

/**
 * Formats a time string for backend API (ensures HH:mm format with leading zeros)
 * @param time - Time string to format
 * @returns Formatted time string in HH:mm format
 */
export const formatTimeForBackend = (time: string): string => {
  const normalized = normaliseTime(time);
  const [hours, minutes] = normalized.split(':');
  return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
};
